/**
 * Module-level visual identity tokens.
 *
 * Each page module (NI, Migration) gets a distinct accent color so users
 * can tell at a glance which module they are on.
 *
 * Status-card colors (Pending/Active/Rescheduled/Cancelled) are NOT part of
 * this system — those represent workflow meaning and stay consistent everywhere.
 */

export const MODULE_THEMES = {
  ni: {
    key: "ni",
    label: "New Installation",
    // Accent strip under the navbar
    strip: "bg-teal-500",
    // Module badge (the left-side label card)
    badge: "bg-teal-600 text-white",
    badgeMobile: "bg-teal-600 text-white",
    // Primary accent buttons (Today, date nav arrows, active toggle)
    btnPrimary: "bg-teal-600 hover:bg-teal-700 text-white",
    btnPrimaryStatic: "bg-teal-600 text-white", // no hover (disabled/active state)
    // Focus ring for inputs on this page
    focusRing: "focus:ring-teal-500",
    // Icon SVG path (house/install icon)
    iconPath: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0h4",
  },
  migration: {
    key: "migration",
    label: "Migration",
    strip: "bg-purple-500",
    badge: "bg-purple-600 text-white",
    badgeMobile: "bg-purple-600 text-white",
    btnPrimary: "bg-purple-600 hover:bg-purple-700 text-white",
    btnPrimaryStatic: "bg-purple-600 text-white",
    focusRing: "focus:ring-purple-500",
    // Icon SVG path (swap/transfer arrows icon)
    iconPath: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4",
  },
  napLocator: {
    key: "napLocator",
    label: "NAP Locator",
    strip: "bg-blue-500",
    badge: "bg-blue-600 text-white",
    badgeMobile: "bg-blue-600 text-white",
    btnPrimary: "bg-blue-600 hover:bg-blue-700 text-white",
    btnPrimaryStatic: "bg-blue-600 text-white",
    focusRing: "focus:ring-blue-500",
    // Icon SVG path (map-pin / location icon)
    iconPath: "M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z",
  },
};
